<template>
    <div class="card-wrapper" style="margin: 0px auto;">
        <div class="card-inner-wrapper">
            <header class="WaveHeaderstyled__WaveHeader-app__sc-1ootntz-0 hYMRDL">
                <div class="card-header">
                    <div class="Avatarstyled__Avatar-app__sc-1gugn1w-0 cKWBBd">
                        <img alt="Mario Colesanti" src="../assets/about/mario.png" class="mario-pic">
                    </div>
                    <div class="img-footer">
                        <svg
                            class="card-wavestyled__Wave-app__sc-4t6hon-0 euHkZp WaveHeaderstyled__Divider-app__sc-1ootntz-2 loBTgy"
                            preserveAspectRatio="xMinYMax meet" viewBox="0 0 246 57" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M 214.7168,6.1113281 C 195.65271,5.9023124 172.37742,11.948182 137.87305,32.529297 110.16613,49.05604 86.980345,56.862784 65.015625,57 H 65 v 1 H 246 V 11.453125 C 236.0775,8.6129313 226.15525,6.2367376 214.7168,6.1113281 Z"
                                fill="#ffffff" clip-rule="evenodd" fill-rule="evenodd"></path>
                            <path
                                d="M 0,35.773438 V 58 H 65 L 64.97852,57 C 43.192081,57.127508 22.605139,49.707997 0,35.773438 Z "
                                fill="#ffffff" clip-rule="evenodd" fill-rule="evenodd"></path>
                            <path fill="#004F7F" clip-rule="evenodd" fill-rule="evenodd"
                                  d="m 0,16.7221 v 19.052 C 45.4067,63.7643 82.6667,65.4583 137.873,32.5286 193.08,-0.401184 219.54,3.87965 246,11.4535 V 6.51403 C 185.24,-16.8661 135.913,29.331 97.6933,40.8564 59.4733,52.3818 33.6467,44.1494 0,16.7221 Z "></path>
                        </svg>
                        <div class="img-footer2"></div>
                        <img alt="Vindome logo" src="../assets/vindome-mobile.png" class="vindome-logo">
                    </div>
                </div>
                <div class="card-information">
                    <div class="card-information-row">
                        <div>
                            <span class="card-name">Mario Colesanti</span>
                        </div>
                        <div>
                            <span class="card-title">Head of Sales & Business Development</span>
                        </div>
                        <div>
                            <span class="card-company">Vindome</span>
                        </div>
                    </div>
                </div>
            </header>
            <div>
                <ul class="card-list">
                    <li tabindex="0"
                        class="mdc-ripple-upgraded list-item__ListItem-app__sc-at3t3c-0 DetailFieldListstyled__ListItem-app__sc-qm7vst-3 dYmHGd jgXNwd mdc-list-item">
                        <div class="DetailFieldListstyled__Actions-app__sc-qm7vst-2 iCXsmq">
                            <div class="DetailFieldListstyled__Action-app__sc-qm7vst-1 dAwOXS">
                                <button role="button" tabindex="0"
                                        class="rmwc-icon rmwc-icon--component material-icons mdc-ripple-upgraded--unbounded mdc-ripple-upgraded icon-button__IconButton-app__sc-1rffspf-0 aKgEF mdc-icon-button"
                                        data-mdc-ripple-is-unbounded="true"
                                        style="--mdc-ripple-fg-size:24px; --mdc-ripple-fg-scale:1.75; --mdc-ripple-left:9px; --mdc-ripple-top:9px;">
                                    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"
                                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                         class="svg-iconstyled__Svg-app__sc-1nwmz4s-0 kZgIbN"
                                         style="fill: currentcolor; height: 1em; overflow: visible; width: 1em;">
                                        <path
                                            d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L12.53 12.67C12.21 12.87 11.79 12.87 11.47 12.67L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <span
                            class="list-item-text__ListItemText-app__sc-rsuhfo-0 DetailFieldListstyled__Text-app__sc-qm7vst-7 iuZGaj kpaTEX mdc-list-item__text">
                            <a href="mailto:mario@vindome.net"
                               class="list-item-primary-text__ListItemPrimaryText-app__sc-12r6697-0 DetailFieldListstyled__PrimaryText-app__sc-qm7vst-5 UyPYw ktIbOf mdc-list-item__primary-text">mario@vindome.net</a>
                        </span>
                    </li>
                    <li tabindex="0"
                        class="mdc-ripple-upgraded list-item__ListItem-app__sc-at3t3c-0 DetailFieldListstyled__ListItem-app__sc-qm7vst-3 dYmHGd jgXNwd mdc-list-item">
                        <div class="DetailFieldListstyled__Actions-app__sc-qm7vst-2 iCXsmq">
                            <div class="DetailFieldListstyled__Action-app__sc-qm7vst-1 dAwOXS">
                                <button role="button" tabindex="0"
                                        class="rmwc-icon rmwc-icon--component material-icons mdc-ripple-upgraded--unbounded mdc-ripple-upgraded icon-button__IconButton-app__sc-1rffspf-0 aKgEF mdc-icon-button"
                                        data-mdc-ripple-is-unbounded="true"
                                        style="--mdc-ripple-fg-size:24px; --mdc-ripple-fg-scale:1.75; --mdc-ripple-left:9px; --mdc-ripple-top:9px;">
                                    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"
                                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                         class="svg-iconstyled__Svg-app__sc-1nwmz4s-0 kZgIbN"
                                         style="fill: currentcolor; height: 1em; overflow: visible; width: 1em;">
                                        <path
                                            d="M19.23 15.26L16.69 14.97C16.08 14.9 15.48 15.11 15.05 15.54L13.21 17.38C10.38 15.94 8.06004 13.63 6.62004 10.79L8.47004 8.94001C8.90004 8.51001 9.11004 7.91001 9.04004 7.30001L8.75004 4.78001C8.63004 3.77001 7.78004 3.01001 6.76004 3.01001H5.03004C3.90004 3.01001 2.96004 3.95001 3.03004 5.08001C3.56004 13.62 10.39 20.44 18.92 20.97C20.05 21.04 20.99 20.1 20.99 18.97V17.24C21 16.23 20.24 15.38 19.23 15.26V15.26Z"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <span
                            class="list-item-text__ListItemText-app__sc-rsuhfo-0 DetailFieldListstyled__Text-app__sc-qm7vst-7 iuZGaj kpaTEX mdc-list-item__text">
                            <a href="callto:0033643914310"
                               class="list-item-primary-text__ListItemPrimaryText-app__sc-12r6697-0 DetailFieldListstyled__PrimaryText-app__sc-qm7vst-5 UyPYw ktIbOf mdc-list-item__primary-text">+33 6 43 91 43 10</a>
                        </span>
                    </li>
                    <li tabindex="0"
                        class="mdc-ripple-upgraded list-item__ListItem-app__sc-at3t3c-0 DetailFieldListstyled__ListItem-app__sc-qm7vst-3 dYmHGd jgXNwd mdc-list-item">
                        <div class="DetailFieldListstyled__Actions-app__sc-qm7vst-2 iCXsmq">
                            <div class="DetailFieldListstyled__Action-app__sc-qm7vst-1 dAwOXS">
                                <button role="button" tabindex="0"
                                        class="rmwc-icon rmwc-icon--component material-icons mdc-ripple-upgraded--unbounded mdc-ripple-upgraded icon-button__IconButton-app__sc-1rffspf-0 aKgEF mdc-icon-button"
                                        data-mdc-ripple-is-unbounded="true"
                                        style="--mdc-ripple-fg-size:24px; --mdc-ripple-fg-scale:1.75; --mdc-ripple-left:9px; --mdc-ripple-top:9px;">
                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                         viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;"
                                         xml:space="preserve">
                                        <g>
                                            <path d="M583.395,267.427L323.019,7.049C318.507,2.535,312.385,0,306,0c-6.385,0-12.506,2.535-17.018,7.049L28.604,267.427
            c-6.884,6.884-8.943,17.236-5.217,26.229c3.726,8.995,12.501,14.857,22.235,14.857h42.637v279.419
            c0,13.293,10.777,24.068,24.07,24.068h387.347c13.293,0,24.07-10.775,24.07-24.068V308.514h42.635
            c9.734,0,18.512-5.863,22.235-14.857C592.338,284.663,590.279,274.311,583.395,267.427z M362.161,535.718h-112.32V408.359
            c0-28.383,23.005-51.377,51.377-51.377h9.564c28.375,0,51.377,22.996,51.377,51.377v127.359H362.161z"/>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <span
                            class="list-item-text__ListItemText-app__sc-rsuhfo-0 DetailFieldListstyled__Text-app__sc-qm7vst-7 iuZGaj kpaTEX mdc-list-item__text">
                            <a href="https://vindome.net" target="_blank"
                               class="list-item-primary-text__ListItemPrimaryText-app__sc-12r6697-0 DetailFieldListstyled__PrimaryText-app__sc-qm7vst-5 UyPYw ktIbOf mdc-list-item__primary-text">https://vindome.net</a>
                        </span>
                    </li>
                    <li tabindex="0"
                        class="mdc-ripple-upgraded list-item__ListItem-app__sc-at3t3c-0 DetailFieldListstyled__ListItem-app__sc-qm7vst-3 dYmHGd jgXNwd mdc-list-item">
                        <div class="DetailFieldListstyled__Actions-app__sc-qm7vst-2 iCXsmq">
                            <div class="DetailFieldListstyled__Action-app__sc-qm7vst-1 dAwOXS">
                                <button role="button" tabindex="0"
                                        class="rmwc-icon rmwc-icon--component material-icons mdc-ripple-upgraded--unbounded mdc-ripple-upgraded icon-button__IconButton-app__sc-1rffspf-0 aKgEF mdc-icon-button"
                                        data-mdc-ripple-is-unbounded="true"
                                        style="--mdc-ripple-fg-size:24px; --mdc-ripple-fg-scale:1.75; --mdc-ripple-left:9px; --mdc-ripple-top:9px;">
                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                         width="49px" height="49px" viewBox="0 0 49 49"
                                         style="enable-background:new 0 0 49 49;" xml:space="preserve">
                                        <g>
                                            <path d="M24.5,0C14.465,0,6.329,8.136,6.329,18.171C6.329,33.076,24.5,49,24.5,49s18.171-15.107,18.171-30.828
                                                C42.671,8.136,34.535,0,24.5,0z M24.5,29.197c-6.202,0-11.229-5.029-11.229-11.229c0-6.202,5.026-11.229,11.229-11.229
                                                c6.201,0,11.229,5.027,11.229,11.229C35.729,24.168,30.701,29.197,24.5,29.197z"/>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <span
                            class="list-item-text__ListItemText-app__sc-rsuhfo-0 DetailFieldListstyled__Text-app__sc-qm7vst-7 iuZGaj kpaTEX mdc-list-item__text">
                            <span
                                class="list-item-primary-text__ListItemPrimaryText-app__sc-12r6697-0 DetailFieldListstyled__PrimaryText-app__sc-qm7vst-5 UyPYw ktIbOf mdc-list-item__primary-text">Vindome Sarl<br/>1 Rue Suffren Reymond<br/>98000 Monaco</span>
                        </span>
                    </li>
                    <li tabindex="0"
                        class="mdc-ripple-upgraded list-item__ListItem-app__sc-at3t3c-0 DetailFieldListstyled__ListItem-app__sc-qm7vst-3 dYmHGd jgXNwd mdc-list-item">
                        <div class="DetailFieldListstyled__Actions-app__sc-qm7vst-2 iCXsmq">
                            <div class="DetailFieldListstyled__Action-app__sc-qm7vst-1 dAwOXS">
                                <button role="button" tabindex="0"
                                        class="rmwc-icon rmwc-icon--component material-icons mdc-ripple-upgraded--unbounded mdc-ripple-upgraded icon-button__IconButton-app__sc-1rffspf-0 aKgEF mdc-icon-button"
                                        data-mdc-ripple-is-unbounded="true"
                                        style="--mdc-ripple-fg-size:24px; --mdc-ripple-fg-scale:1.75; --mdc-ripple-left:9px; --mdc-ripple-top:9px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                         width="50" height="50"
                                         viewBox="0 0 50 50"
                                         style=" fill:#ffffff;">
                                        <path
                                            d="M25,2C12.297,2,2,12.297,2,25s10.297,23,23,23s23-10.297,23-23S37.703,2,25,2z M25,11c1.657,0,3,1.343,3,3s-1.343,3-3,3 s-3-1.343-3-3S23.343,11,25,11z M29,38h-2h-4h-2v-2h2V23h-2v-2h2h4v2v13h2V38z"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <span
                            class="list-item-text__ListItemText-app__sc-rsuhfo-0 DetailFieldListstyled__Text-app__sc-qm7vst-7 iuZGaj kpaTEX mdc-list-item__text">
                            <span
                                class="list-item-primary-text__ListItemPrimaryText-app__sc-12r6697-0 DetailFieldListstyled__PrimaryText-app__sc-qm7vst-5 UyPYw ktIbOf mdc-list-item__primary-text">VAT: FR38 000 143 213</span>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MarioColesanti",
        head: {
            title: 'Mario Colesanti | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'mario-page'
            }
        }
    }
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;600;800&display=swap');

    .card-wrapper {
        background-color: rgb(242, 242, 242);
        border-radius: 1rem;
        display: flex;
        flex-direction: column;
        font-family: "Nunito Sans", sans-serif;
        line-height: 0;
        max-width: 440px;
        min-width: 320px;
        overflow: hidden;
        transform: translateZ(0px);
        width: 100%;
    }

    .card-header {
        min-height: 12rem;
        position: relative;
        transition-duration: 300ms;
        transition-property: background-color;
        will-change: background-color;
    }

    .mario-pic {
        width: 100%;
    }

    .img-footer {
        bottom: -2px;
        left: -2px;
        position: absolute;
        width: calc(100% + 4px);
    }

    .card-inner-wrapper {
        flex: 1 1 0;
        background-color: rgb(255, 255, 255);
    }

    .card-inner-wrapper::before {
        display: block;
        height: 0;
    }

    .img-footer2 {
        inset: 30% 0 0 65%;
        position: absolute;
    }

    .card-information {
        margin: 1.5rem;
    }

    .card-information-row {
        border-left: 1px dashed black;
        padding-left: 1.5rem;
    }

    .card-name {
        font-size: 1.75rem;
        font-weight: 800;
        line-height: 2.25rem;
    }

    .card-title {
        font-size: 1.25rem;
        line-height: 2rem;
        font-weight: 600;
        white-space: pre-wrap;
    }

    .card-company {
        font-size: 1.25rem;
        line-height: 2rem;
        font-style: italic;
        font-weight: 300;
    }

    .card-list {
        display: flex;
        flex-direction: column;
        list-style-type: none;
        padding: 0;
    }

    .card-list:first-child {
        padding-top: 1rem;
    }

    .card-list li {
        -webkit-box-align: center;
        align-items: center;
        flex: 1 1;
        height: auto;
        margin: 0;
        padding: 0.5rem 1.5rem;
        display: flex;
        position: relative;
    }

    .iCXsmq {
        align-self: flex-start;
        display: flex;
    }

    .dAwOXS {
        align-self: flex-start;
        height: 42px;
        margin-right: 0.8125rem;
        width: 42px;
    }

    .dAwOXS button {
        -webkit-box-align: center;
        align-items: center;
        background-color: #004F7F;
        border-radius: 100%;
        color: rgb(255, 255, 255);
        display: inline-flex;
        height: 100%;
        -webkit-box-pack: center;
        justify-content: center;
        padding: 0;
        transition-duration: 300ms;
        transition-property: background-color, color;
        width: 100%;
    }

    .kpaTEX {
        display: flex;
        flex: 1 1 0;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .ktIbOf {
        font-size: 1.1rem;
        line-height: 1.5em;
        margin: 0;
        white-space: pre-wrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-decoration: none;
        color: #000000;
    }

    .kZgIbN {
        display: inline-block;
        height: auto;
        transition-duration: 300ms;
        transition-property: fill, stroke, opacity, transform, width;
        user-select: none;
    }

    .mdc-icon-button img,
    .mdc-icon-button svg {
        width: 24px;
        height: 24px;
    }

    .mdc-icon-button {
        display: inline-block;
        position: relative;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        border: none;
        outline: none;
        background-color: transparent;
        fill: currentColor;
        color: inherit;
        font-size: 24px;
        text-decoration: none;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        width: 48px;
        height: 48px;
        padding: 12px;
    }

    .vindome-logo {
        width: 50px;
        height: 50px;
        bottom: 0;
        right: 32px;
        position: absolute;
    }
</style>
<style>
    .mario-page .header-toolbar,
    .mario-page .header-toolbar-not-logged,
    .mario-page .main-footer {
        display: none !important;
    }

    .mario-page .v-main {
        padding-top: 0 !important;
    }
</style>
